import lodash from "lodash";
import { App } from "antd";
import { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  addAboveForMerge,
  changeInfoForMerge,
  changeSpeakerForMerge,
  removeForMerge,
  resetContentForMerge,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import {
  draftDialogCommentsSelector,
  draftDialogMergeRawSelector,
  draftDialogMergeSelector,
  draftDialogSpeakersSelector,
} from "store/bailiff/draft/dialog/draft_dialog.selector";
import { firebaseSaveDraftDialog } from "store/bailiff/draft/dialog_edited/dialog_edited.action";
import { draftDialogEditedSelector } from "store/bailiff/draft/dialog_edited/dialog_edited.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useActionDraftMerge = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const merge = useSelector(draftDialogMergeSelector);
  // -------------------------- FUNCTION ------------------------
  const handleChangeSpeaker = useCallback(
    (id, speaker) => {
      if (!merge) return message.error("Data not found!");
      console.log({ id, speaker });
      dispatch(changeSpeakerForMerge({ data: merge, id, speaker }));
    },
    [dispatch, merge, message],
  );

  const handleAddAboveSpeaker = useCallback(
    (id) => {
      if (!merge) return message.error("Data not found!");
      dispatch(addAboveForMerge({ data: merge, id }));
    },
    [dispatch, merge, message],
  );

  const handleResetContentMerge = useCallback(
    (id) => {
      if (!merge) return message.error("Data not found!");
      dispatch(resetContentForMerge({ data: merge, id }));
    },
    [dispatch, merge, message],
  );

  const handleUpdateInfoMerge = useCallback(
    (id, info) => {
      if (!merge) return message.error("Data not found!");
      const { from, to, text } = info;
      console.log({ id, from, to, text });
      dispatch(changeInfoForMerge({ data: merge, id, from, to, fix: text }));
    },
    [dispatch, merge, message],
  );

  const handleDeleteMerge = useCallback(
    (id) => {
      if (!merge) return message.error("Data not found!");
      dispatch(removeForMerge({ data: merge, id }));
    },
    [dispatch, merge, message],
  );

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    handleChangeSpeaker,
    handleAddAboveSpeaker,
    handleUpdateInfoMerge,
    handleResetContentMerge,
    handleDeleteMerge,
  };
};

//save
export const useActionDraftMergeSave = () => {
  // -------------------------- VAR -----------------------------
  const { message, modal } = App?.useApp();
  const params = useParams();
  const bailiffId = params?.bailiffId || null;
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const merged = useSelector(draftDialogMergeSelector);
  const speakers = useSelector(draftDialogSpeakersSelector);
  const comments = useSelector(draftDialogCommentsSelector);
  console.log({ merged });
  // -------------------------- FUNCTION ------------------------
  const showModalConfirm = () => {
    modal.confirm({
      title: "Xác nhận Lưu vào hệ thống",
      centered: true,
      content:
        "Hành động này không thể hoàn tác, vui lòng không đóng hộp thoại và chuyển màn hình khi đang lưu",
      onCancel: () => {},
      onOk: () => {
        handleSaveDialogEdited();
      },
    });
  };

  // save
  const handleSaveDialogEdited = () => {
    if (!bailiffId || !merged || !speakers || !comments)
      return message.error("Data not found!");
    setLoading(true);
    const key = "updatable";
    dispatch(
      firebaseSaveDraftDialog(
        {
          merged,
          voices: speakers,
          comments,
          bailiff: bailiffId,
        },
        (res) => {
          setLoading(false);
          if (res?.status === 200) {
            message.success({ content: "Lưu dữ liệu thành công", key });
          }
          if (res?.status === 500) {
            message.error({ content: res?.data, key });
          }
          if (res?.status === 100) {
            const percent = res?.data;
            message.loading({ content: `Đang xử lý (%${percent})`, key });
          }
        },
      ),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, showModalConfirm };
};

//refine
export const useActionDraftMergeRefine = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const merge = useSelector(draftDialogMergeRawSelector);
  const edited = useSelector(draftDialogEditedSelector);
  const compareFrom = (a, b) => {
    const aHasFix = a?.fix !== undefined && a?.fix !== "";
    const bHasFix = b?.fix !== undefined && b?.fix !== "";
    const aHasFixFrom = a?.fixFrom !== undefined && a?.fixFrom !== "";
    const bHasFixFrom = b?.fixFrom !== undefined && b?.fixFrom !== "";
    const isAUpdated = a?.update || (aHasFix && aHasFixFrom);
    const isBUpdated = b?.update || (bHasFix && bHasFixFrom);
    const fromA = isAUpdated ? a.fixFrom : a.from;
    const fromB = isBUpdated ? b.fixFrom : b.from;
    // console.log({ a, isAUpdated });
    return fromA - fromB;
  };
  const sorted = useMemo(() => {
    const combine = refineData({ merge, edited });
    const sorted = combine.sort(compareFrom);

    return sorted;
  }, [merge, edited]);

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data: sorted };
};

const refineData = ({ merge, edited }) => {
  const dataMerge = lodash.cloneDeep(merge) || [];
  const dataEdited = lodash.cloneDeep(edited) || [];

  dataEdited?.forEach((edited) => {
    const add = edited?.add;
    const update = edited?.update;
    const remove = edited?.remove;

    const index = dataMerge?.findIndex((d) => {
      const valid = d?.segId === edited?.repId;

      return valid;
    });

    if (remove && index >= 0) {
      // xoá.
      dataMerge.splice(index, 1);
    }

    if (!remove && add) {
      dataMerge.push(edited);
    }

    if (!remove && !add && update && index >= 0) {
      dataMerge[index] = {
        ...dataMerge[index],
        text: edited?.text,
        from: edited?.from,
        to: edited?.to,
        fix: edited?.fix || "",
        fixFrom: edited?.fixFrom,
        fixTo: edited?.fixTo,
        fixSpeaker: edited?.fixSpeaker || "",
        docId: edited?.docId,
      };
    }
  });

  return dataMerge;
};
